module.exports = __webpack_public_path__ + "img/logo.c4a4bc15.svg";